export default __webpack_public_path__ + "static/media/web-design.f48724bb.png";